// Foundations
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';

// Services
import { MyProfileService } from 'src/app/services/my-profile.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

// Components
import { EditPreferredLocationComponent } from 'src/app/components/my-profile/camp-locations/edit-preferred-location/edit-preferred-location.component';

@Component({
  selector: 'app-camp-locations-page',
  templateUrl: './camp-locations-page.component.html',
  styleUrls: ['./camp-locations-page.component.scss']
})
export class CampLocationsPageComponent implements OnInit {

  @ViewChild('editPreferredLocation', { static: false }) editPreferredLocation: EditPreferredLocationComponent;

  // 0 -> Camp Location List
  // 1 -> Edit Preferred Location
  // 2 -> Search Preferred Location
  step = 0;

  @Input() isFirstTime: boolean;

  @Output() navigateToCamperApp = new EventEmitter<number>();

  constructor(
    public myProfileService: MyProfileService,
    private _analytics: AnalyticsService
  ) { }

  ngOnInit(): void {
    this.myProfileService.fetchLocationList();
  }

  handlePageContent(step): void {
    this.step = step;

    //
    if (step === 0) {
      this._analytics.logButtonTap('myProfile_editPreferredLocation');
    }
  }

  onContinue() {
    this._analytics.logButtonTap('myProfile_saveStepPreferredLocation');
    this.navigateToCamperApp.emit(3);
  }
}
